export const paNumber = {
    random(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    },
    percent(value, total, floatToFixed) {
        let isFloatToFixed = typeof floatToFixed != 'undefined';
        floatToFixed = floatToFixed || 1;
        let percent = (value / total * 100);
        if (this.isFloat(percent) && isFloatToFixed) {
            return percent.toFixed(floatToFixed);
        }
        return percent.toFixed(0);
    },
    isFloat(n) {
        return Number(n) === n && n % 1 !== 0;
    },
    median(values) {
        values.sort(function (a, b) {
            return a - b;
        });
        let half = Math.floor(values.length / 2);

        if (values.length == 2 || values.length == 1) {
            return values[0];
        } else if (values.length == 0) {
            return;
        }

        return values.length % 2 ? values[half - 1] : values[half];
    }
};


// WEBPACK FOOTER //
// ./src/js/framework/helpers/paNumber.js